<template>
  <div>
    <div class="customer-purchase-analysis">
      <CCard title="تحلیل خریدهای مشتریان" class="mb-4">
        <CRow>
          <CCol col="6">
            <CFormGroup label="جستجو">
              <CInput v-model="filter" placeholder="جستجوی مشتری..."/>
              <CButton :disabled="!filter" @click="filter = ''">پاک کردن</CButton>


            </CFormGroup>
          </CCol>
          <CCol md="3">
            <CSelect :value.sync="minOrders" :options="orderOptions"/>
          </CCol>
          <CCol md="3">

            <CSelect :value.sync="sortBy" :options="sortOptions"/>
          </CCol>
        </CRow>
      </CCard>

      <CCard>
        <CDataTableFixed
            :items="filteredCustomers"
            :fields="fields"
sorter
            column-filter
            striped
            hover
            responsive
            show-empty
        >
          <template #customer_name="{item}">
            <td>
              <strong>{{ item.customer_name }}</strong>
              <br>
              <small class="text-muted">{{ item.email }}</small>
            </td>
          </template>

          <template #total_orders="{item}">
            <td>
              <CBadge color="info">{{ get_currency(item.total_orders) }}</CBadge>

            </td>
          </template>

          <template #last_order_date="{item}">
           <td>
             {{ item.last_order_date }}
             <br>
             <small :class="getDaysClass(item.days_since_last_order)">
               ({{ item.days_since_last_order }} روز گذشته)
             </small>
           </td>

          </template>

          <template #favorite_product="{item}">
            <td>
              <div v-if="item.favorite_product">
                <strong>{{ item.favorite_product }}</strong>
                <br>
                <small class="text-muted">
                  {{ item.favorite_product_count }} عدد خریداری شده
                </small>
              </div>
              <span v-else class="text-muted">بدون اطلاعات</span>
            </td>

          </template>

          <template #favorite_brand="{item}">
            <td>
              <CBadge v-if="item.favorite_brand" color="success">{{ item.favorite_brand }}</CBadge>
              <span v-else class="text-muted">بدون اطلاعات</span>
            </td>

          </template>

          <template #favorite_category="{item}">
           <td>
             <CBadge v-if="item.favorite_category" color="warning">{{ item.favorite_category }}</CBadge>
             <span v-else class="text-muted">بدون اطلاعات</span>
           </td>

          </template>

          <template #total_spent="{item}">
            <td>
              <div class="text-success">
                <strong>{{ get_currency(item.total_spent) }}</strong>
              </div>
            </td>
          </template>
 <template #avg_order_value="{item}">
            <td>
              <div class="text-success">
                <strong>{{ get_currency(item.avg_order_value) }}</strong>
              </div>
            </td>
          </template>

          <template #actions="{item}">
<td>
  <CButtonGroup size="sm">
    <CButton @click="viewCustomerDetails(item)" color="info">
      جزئیات
    </CButton>
    <CButton @click="sendPersonalizedOffer(item)" color="success">
      ارسال پیشنهاد
    </CButton>
  </CButtonGroup>
</td>

          </template>

          <template #empty>
            <div class="text-center text-muted py-4">
              هیچ مشتریی یافت نشد
            </div>
          </template>
        </CDataTableFixed>


      </CCard>

      <!-- مودال جزئیات مشتری -->
      <CModal :show.sync="showDetailModal"  size="lg">
        <div v-if="selectedCustomer!=null">
          <CRow>
            <CCol col="6">
              <CCard no-body>
                <CCardHeader>اطلاعات تماس</CCardHeader>
                <CCardBody>
                  <p><strong>نام:</strong> {{ selectedCustomer.customer_name }}</p>
                  <p><strong>ایمیل:</strong> {{ selectedCustomer.email }}</p>
                  <p><strong>تلفن:</strong> {{ selectedCustomer.phone }}</p>
                </CCardBody>
              </CCard>
            </CCol>

            <CCol md="6">
              <CCard no-body>
                <CCardHeader>آمار خرید</CCardHeader>
                <CCardBody>
                  <p><strong>تعداد خریدها:</strong> {{ selectedCustomer.total_orders }}</p>
                  <p><strong>مجموع مبلغ خرید:</strong> {{ formatCurrency(selectedCustomer.total_spent) }}</p>
                  <p><strong>میانگین ارزش خرید:</strong> {{ formatCurrency(selectedCustomer.avg_order_value) }}</p>
                  <p><strong>آخرین خرید:</strong> {{ formatDate(selectedCustomer.last_order_date) }}</p>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>

          <CCard no-body class="mt-3">
            <CCardHeader>ترجیحات خرید</CCardHeader>
            <CCardBody>
              <CRow>
                <CCol md="4">
                  <h6>پرخریدترین محصول</h6>
                  <p class="text-info">{{ selectedCustomer.favorite_product || 'بدون اطلاعات' }}</p>
                  <small>{{ selectedCustomer.favorite_product_count }} عدد خریداری شده</small>
                </CCol>
                <CCol md="4">
                  <h6>برند محبوب</h6>
                  <p class="text-success">{{ selectedCustomer.favorite_brand || 'بدون اطلاعات' }}</p>
                </CCol>
                <CCol md="4">
                  <h6>دسته‌بندی محبوب</h6>
                  <p class="text-warning">{{ selectedCustomer.favorite_category || 'بدون اطلاعات' }}</p>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </div>

      </CModal>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'AdvancedAnalyticsDashboard',
  data() {
    return {
      customers: [],
      filter: '',
      minOrders: 1,
      sortBy: 'total_spent',
      sortDesc: true,
      currentPage: 1,
      perPage: 10,
      showDetailModal: false,
      selectedCustomer: null,

      fields: [
        { key: 'customer_name', label: 'مشتری', sortable: true },
        { key: 'phone', label: 'تلفن' },
        { key: 'total_orders', label: 'تعداد خرید', sortable: true },
        { key: 'last_order_date', label: 'آخرین خرید', sortable: true },
        { key: 'favorite_product', label: 'پرخریدترین محصول' },
        { key: 'favorite_brand', label: 'برند محبوب' },
        { key: 'favorite_category', label: 'دسته‌بندی محبوب' },
        { key: 'total_spent', label: 'مجموع خریدها', sortable: true },
        { key: 'avg_order_value', label: 'میانگین ارزش خرید', sortable: true },
        { key: 'actions', label: 'اقدامات' }
      ],

      orderOptions: [
        { value: 1, text: '1+ خرید' },
        { value: 3, text: '3+ خرید' },
        { value: 5, text: '5+ خرید' },
        { value: 10, text: '10+ خرید' }
      ],

      sortOptions: [
        { value: 'total_spent', text: 'مجموع خریدها' },
        { value: 'total_orders', text: 'تعداد خریدها' },
        { value: 'last_order_date', text: 'تاریخ آخرین خرید' },
        { value: 'avg_order_value', text: 'میانگین ارزش خرید' }
      ]
    }
  },

  computed: {
    filteredCustomers() {
      return this.customers.filter(customer =>
          customer.total_orders >= this.minOrders
      );
    },

    totalRows() {
      return this.filteredCustomers.length;
    }
  },

  mounted() {
    this.loadCustomerData();


  },

  methods: {
    async loadCustomerData() {
      try {
        const response = await axios.get('/api/admin/analytics/customer-purchase-history');
        this.customers = response.data;
      } catch (error) {
        console.error('Error loading customer data:', error);
        this.$notify.error('خطا در بارگذاری داده‌های مشتریان');
      }
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString('fa-IR');
    },

    formatCurrency(value) {
      return new Intl.NumberFormat('fa-IR').format(value) + ' تومان';
    },

    getDaysClass(days) {
      if (days > 90) return 'text-danger';
      if (days > 30) return 'text-warning';
      return 'text-success';
    },

    viewCustomerDetails(customer) {
      this.selectedCustomer = customer;
      this.showDetailModal = true;
    },

    sendPersonalizedOffer(customer) {
      this.$bvModal.msgBoxConfirm(
          `آیا می‌خواهید برای ${customer.customer_name} پیشنهاد ویژه ارسال کنید؟`,
          {
            title: 'ارسال پیشنهاد ویژه',
            okVariant: 'success',
            okTitle: 'ارسال',
            cancelTitle: 'لغو'
          }
      ).then(confirmed => {
        if (confirmed) {
          this.$notify.success(`پیشنهاد برای ${customer.customer_name} ارسال شد`);
        }
      });
    }
  }

}
</script>

<style scoped>
.advanced-analytics {
  padding: 20px;
}

.card {
  margin-bottom: 20px;
  border: none;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.table {
  font-size: 0.9rem;
}

.badge {
  font-size: 0.8rem;
  padding: 0.4em 0.6em;
}
</style>